import { useState } from 'react';
import { createPortal } from 'react-dom';
import useSettings from '@/hooks/useSettings';
import { getOppositeColor, applyTransparency } from '@/utils/colors';

import LinkButton from '@/components/common/LinkButton';
import { isNommi } from '@/utils/brand';

export default function AboutCpf() {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <LinkButton
        onOpen={() => setShowModal(true)}
        spanClassName="-mt-1.5 -mb-3 text-xs leading-4 LinkButton text-[#36B37E]"
      >
        Porque pedimos esse dado?
      </LinkButton>

      {showModal &&
        createPortal(<ModalContent onClose={() => setShowModal(false)} />, document.body)}
    </>
  );
}

function ModalContent({ onClose }: any) {
  const settings = useSettings();

  return (
    <div
      style={{
        backgroundColor: applyTransparency(getOppositeColor(settings.backgroundColor), 0.5)
      }}
      className={`fixed inset-0 z-50 flex items-center justify-center  bg-opacity-50`}
    >
      <div
        style={{
          backgroundColor: settings.form.background.color
        }}
        className="bg-gray-800 rounded-lg shadow-lg p-6 max-w-md mx-4"
      >
        <div className="flex flex-col">
          <h2
            style={{
              color: settings.text.color.primary
            }}
            className="text-lg font-semibold text-white mb-4"
          >
            Sobre CPF/CNPJ
          </h2>
          <p
            style={{
              color: settings.text.color.secondary
            }}
            className="text-sm text-gray-400 mb-6"
          >
            Esse dado é necessário para garantir a segurança da sua compra e cadastro em nossa
            plataforma, essa informação também pode ser usada para emissão de Nota Fiscal.
          </p>
          <button
            onClick={onClose}
            style={{
              backgroundColor: isNommi ? '#2886B9' : settings.payButton.color,
              color: settings.payButton.text.color,
              opacity: 1
            }}
            className="px-6 py-2 bg-[#0F7864] text-white rounded-md hover:bg-[#0b6856] hover:shadow-button-hover transition-colors w-full"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
